<template>
  <div>
    <div class="about_us_top">
      <div class="top_image_nav">
        <img src="../../assets/image/leBaiBaiImg/leLogoTwo.png" class="small_image">
        <span class="title_span">热摆摆网络科技</span>
        <div class="tab_box">
          <el-tabs v-model="activeName3" @tab-click="handleClick3">
            <el-tab-pane label="首页" name="/reBaiBai"></el-tab-pane>
            <el-tab-pane label="关于我们" name="reBaiAbout"></el-tab-pane>
            <el-tab-pane label="APP入驻" name="APP入驻" ></el-tab-pane>
            <el-tab-pane label="云游戏" name="云游戏"></el-tab-pane>
            <el-tab-pane label="微信小游戏" name="微信小游戏"></el-tab-pane>
            <el-tab-pane label="APP中心" name="APP中心"></el-tab-pane>
            <el-tab-pane label="开放平台" name="开放平台"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <div class="about_us_middle" id="companyProfile">
      <img src="../../assets/image/aboutUsImg/jianJie.png" class="middle_image_one"/>
      <span class="company_introduction_box">厦门热摆摆网络科技有限公司拥有百万级的用户基数，通过打造实时在线招聘平台，运用了网络媒体及先进的移动端信息技术，加上经验丰富的专业顾问队伍，提供全方位专业人力资源服务，不断拓展生态边界。凭借大数据和AI技术打造开放的人力资本生态，让人才和机会更精准高效的建立连接，为生态内的合作伙伴创造更多价值。</span>
      <img src="../../assets/image/aboutUsImg/Group14.png" class="middle_image_tow"/>
      <img src="../../assets/image/aboutUsImg/lianXiWoMen.png" class="middle_image_three" id="contanctUs"/>
      <div class="cantact_box" >
        <ul>
          <li class="my_li">
            <img src="../../assets/image/aboutUsImg/keFu.png" class="li_image"/>
            <span class="li_big_span">客服热线</span>
            <span class="li_small_span">0592-5535810</span>
          </li>
          <li class="my_li">
            <img src="../../assets/image/aboutUsImg/weiXin.png" class="li_image"/>
            <span class="li_big_span">商务合作微信</span>
            <span class="li_small_span"> xianyunana8888</span>
          </li>
          <li class="my_li">
            <img src="../../assets/image/aboutUsImg/dingWei.png" class="li_image"/>
            <span class="li_big_span">公司地址</span>
            <span class="li_small_span">厦门市思明区软件园二期观日路18号楼601-5</span>
          </li>
        </ul>
      </div>
      <img src="../../assets/image/aboutUsImg/bianZu3.png" class="middle_image_four"/>
      <img src="../../assets/image/aboutUsImg/changjianwenti.png" class="middle_image_five" id="moreQuestion"/>
      <ul>
        <li class="tow_li_box" >
          <img src="../../assets/image/aboutUsImg/juXing.png" class="small_rct_image"/>
          <span style="font-size: 0.6rem;z-index: 3;display: block;margin-left: 0.5rem;margin-top: -1.6rem;color: white">01</span>
          <span class="tow_li_big">在有檬兼职找工作是否收费？</span>
          <span class="tow_li_small">通过有檬兼职找信息是完全免费的，不收取任何费用。建议您充分填写您的“个人简历”以便我们为您提供个性化服务</span>
        </li>
        <li class="tow_li_box">
          <img src="../../assets/image/aboutUsImg/juXing.png" class="small_rct_image"/>
          <span style="font-size: 0.6rem;z-index: 3;display: block;margin-left: 0.5rem;margin-top: -1.5rem;color: white">02</span>
          <span class="tow_li_big">有檬兼职发布兼职信息如何收费？</span>
          <span class="tow_li_small">在有檬兼职发布兼职信息有不同的收费模式，具体可进入招聘管理页面查看各类套餐详情或可拨打企业业务热线（0592-5535810）咨询。</span>
        </li>
        <li class="tow_li_box">
          <img src="../../assets/image/aboutUsImg/juXing.png" class="small_rct_image"/>
          <span style="font-size: 0.6rem;z-index: 3;display: block;margin-left: 0.5rem;margin-top: -1.5rem;color: white">03</span>
          <span class="tow_li_big">个人用户如何发布兼职信息？</span>
          <span class="tow_li_small">目前有檬兼职并不支持个人用户直接发布兼职信息，您可以重新注册企业账户进行认证后发布。</span>
        </li>
      </ul>
    </div>
    <div class="index_bottom_box">
      <img src="../../assets/image/leBaiBaiImg/leLogoTwo.png" style="width:110px;height:110px;margin-top: 11rem;margin-left: 28.5rem;border-radius: 8px"/>
      <span class="bottom_company_name">厦门口袋零钱网络科技有限公司</span>
      <span class="shou_ye">首页</span>
      <span style="display: block;margin-top: -1.5rem;margin-left: 54.2rem;color: #FFFFFF">|</span>
      <span class="qi_ye">企业服务</span>
      <span style="display: block;margin-top: -1.5rem;margin-left: 64.6rem;color: #FFFFFF">|</span>
      <span class="guan_yu">关于我们</span>
      <span style="display: block;margin-top: -1.5rem;margin-left: 74.6rem;color: #FFFFFF">|</span>
      <span class="guan_yu" style="margin-left: 77.8rem">联系我们</span>
      <ul>
        <li style="color: #8E9DC3;width: 4.3rem;height: 1.25rem;margin-left: 47.85rem;margin-top: 1.8rem;list-style: none"><a href="/reBaiBai#companyProduct"style="color: #333333;">旗下产品</a></li>
        <li style="color: #8E9DC3;width: 4.3rem;height: 1.25rem;margin-left: 47.85rem;margin-top: 1.8rem;list-style: none"><a href="/reBaiBai#recuirtService" style="color: #333333;">招聘服务</a></li>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 47.85rem;margin-top: 1.8rem;list-style: none"><a href="/reBaiBai#ourPhilosophy" style="color: #333333;">我们的理念</a></li>
      </ul>
      <ul>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 57.85rem;margin-top: -7.2rem;list-style: none"><a style="color: #333333;" href="/reBusiness#qualityService">优质服务</a></li>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 57.85rem;margin-top: 1.8rem;list-style: none"><a style="color: #333333;" href="/reBusiness#merchantsMove">商家入驻</a></li>
      </ul>
      <ul>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 67.85rem;margin-top: -4.2REM;list-style: none"><a style="color: #333333;" href="/reBaiAbout#companyProfile">公司简介</a></li>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 67.85rem;margin-top: 1.8rem;list-style: none"><a style="color: #333333;" href="/reBaiAbout#contanctUs">联系我们</a></li>
        <li style="color: #8E9DC3;width: 5rem;height: 1.25rem;margin-left: 67.85rem;margin-top: 1.8rem;list-style: none"><a style="color: #333333;" href="/reBaiAbout#moreQuestion">常见问题</a></li>
      </ul>
      <ul>
        <li style="color: #333333;width: 9.8rem;height: 1.25rem;margin-left: 77.85rem;margin-top: -4.2rem;list-style: none">商务合作邮箱：3348759773@qq.com</li>
        <li style="color: #333333;width: 9.8rem;height: 1.25rem;margin-left: 77.85rem;margin-top: -4.2rem;list-style: none">客服热线：&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp 0592-5535810</li>
      </ul>
      <div class="bottom_bg">
        <span class="bottom_bg_span">© 2021 厦门口袋零钱网络科技有限公司. 版权所有 </span>
        <a class="bottom_bg_a" href="https://beian.miit.gov.cn/#/Integrated/index" style="color: #333333">闽ICP备18019105号-3</a>
      </div>
    </div>

  </div>
</template>

<script>
const urls = require('../../../url');
export default {
  name: "aboutUs",
  data(){
    return{
      active:2,
      activeName3: 'reBaiAbout',
    }
  },
  methods:{
    handleClick3(tab) {
      if(tab.paneName==='/reBaiBai'){
        this.$router.push(tab.paneName)
      }else{
        this.activeName1 = tab.paneName
      }
    }
  }
}
</script>

<style scoped>
.about_us_top{
  width: 100%;
  height: 56.6rem;
  background-image: url("../../assets/image/leBaiBaiImg/aboutIndex.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: relative;
  background-position: center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.index_bottom_box{
  width: 100%;
  height: 31.75rem;
  background-color: rgb(240,242,245);
  background-image: url("../../assets/image/leBaiBaiImg/reBaiBottom.png");
  background-repeat: no-repeat;
  position: relative;
  background-position: center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.top_image_nav{
  position: absolute;
  width: 85%;
  height: 5rem;
  top: 5rem;
  left: 8.125rem;
}

.small_image {
  width: 40px;
  height: 40px;
  display: block;
  margin-left: 0.1rem;
  margin-top: 1.1rem;
  border-radius: 5px;
}

.title_span {
  color: white;
  font-size: 28px;
  display: block;
  margin-left: 56px;
  margin-top: -41px;
}

.about_us_middle{
  width: 100%;
  height: 145.8rem;
}
.middle_image_one{
  margin-left: 21.4rem;
  margin-top: 9.25rem;
}
.company_introduction_box{
  width: 36.8rem;
  height: 7rem;
  display: block;
  font-size: 0.875rem;
  margin-left: 41.6rem;
  margin-top: 0.7rem;
}
.middle_image_tow{
  margin-left: 35.1rem;
  margin-top: 1rem;
}
.middle_image_three{
  margin-left: 22.6rem;
  margin-top: 5.75rem;
}
.cantact_box{
  width: 26rem;
  height: 25.4rem;
  margin-left: 22.6rem;
  background-color: rgb(232, 87, 35);
  display: flex;
  align-items: center;
}
.my_li{
  width: 11.25rem;
  height: 3.2rem;
  margin-top: 1.5rem;
  list-style: none;
  margin-left: 5rem;
}
.li_image{
  margin-top: 0.7rem;
}
.li_big_span{
  color: #FFFFFF;
  font-size: 1.1rem;
  display: block;
  margin-top: -3rem;
  margin-left: 2.5rem;
}
.li_small_span{
  font-size: 0.875rem;
  color: #FFFFFF;
  display: block;
  margin-left: 2.5rem;
  margin-top: 0.5rem;
}
.middle_image_four{
  margin-left: 49.75rem;
  margin-top: -25.5rem;
  display: block;
}
.middle_image_five{
  margin-left: 29rem;
  margin-top: 2rem;
}
.tow_li_box{
  width: 50.8rem;
  height: 4rem;
  margin-top: 3.1rem;
  list-style: none;
  margin-left: 22.6rem;
}
.small_rct_image{
  margin-left: 0.2rem;
  margin-top: 0.2rem;
}
.tow_li_big{
  font-size: 1.3rem;
  color: #333333;
  display: block;
  margin-left: 2rem;
  margin-top: -1rem;
}
.tow_li_small{
  font-size: 0.8rem;
  color: #333333;
  display: block;
  margin-left: 2rem;
  margin-top: 1rem;
}
.bottom_bg{
  width: 100%;
  height: 4.3rem;
  background-color: rgb(222, 91, 50);
  margin-top: 10rem;
}
.bottom_bg_span{
  width: 17rem;
  height: 2.75rem;
  display: inline-block;
  font-size: 0.75rem;
  text-align: center;
  /*color: #8E9DC3;*/
  color: #333333;
  margin-top: 0.75rem;
  margin-left: 51.6rem;
}
.bottom_bg_a{
  width: 17rem;
  height: 2.75rem;
  font-size: 0.75rem;
  /*color: #8E9DC3;*/
  color: #333333;
  text-align: center;
  display: block;
  margin-left: 52rem;
  margin-top: -1rem;
}
/*去除标签页下的线*/
.el-tabs__nav-wrap:after {
  background-color: transparent;
}
/*修改线的位置*/
.el-tabs__active-bar {
  bottom: 0.45rem;
}
/*修改标签颜色*/
.el-tabs__item.is-active {
  color: white;
}

</style>



// WEBPACK FOOTER //
// src/components/reBaiBai/reBaiAbout.vue